var $29308812a020d5fb$exports = {};
$29308812a020d5fb$exports = {
    "maximum": `M\xe1ximo`,
    "minimum": `M\xednimo`
};


export {$29308812a020d5fb$exports as default};
//# sourceMappingURL=es-ES.mjs.map
